"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("react-rangeslider/lib/index.css");
const React = require("react");
const colors_1 = require("../styles/colors");
const react_rangeslider_1 = require("react-rangeslider");
const getStyle = (style, property, value) => {
    if (style && style[property] !== undefined) {
        return style[property];
    }
    return value;
};
const SliderComponent = ({ min, max, value, containerStyle, fillStyle, handleStyle, onChange, }) => {
    let container = Object.assign({ width: 240, height: 24, display: 'flex', alignItems: 'center' }, containerStyle);
    return (React.createElement("div", null,
        React.createElement("div", { className: "roverSlider", style: container },
            React.createElement("style", { type: "text/css" }, `
                    .roverSlider .rangeslider.rangeslider-horizontal {
                        display: block;
                        background: ${getStyle(fillStyle, 'unfilledBackground', colors_1.cloud)};
                        width: 100%;
                        height: ${getStyle(fillStyle, 'height', '2px')};
                        margin: 0;
                    }

                    .roverSlider .rangeslider__fill { 
                        background: ${getStyle(fillStyle, 'filledBackground', colors_1.turquoise)};
                        border-radius: none;
                        -webkit-box-shadow: none;
                       
                    }
                
                    .roverSlider .rangeslider__handle {
                        cursor: default;
                        height: ${getStyle(handleStyle, 'height', '16px')};
                        width: ${getStyle(handleStyle, 'width', '16px')};
                        border-radius: ${getStyle(handleStyle, 'borderRadius', '8px')};
                        border: ${getStyle(handleStyle, 'border', `2px solid ${colors_1.silver}`)};
                        
                        -webkit-box-shadow: none;
                        padding-right: 0px;
                        padding-left: 0px;
                    }

                    .rangeslider-horizontal .rangeslider__handle:after {
                        display: none;
                    }

                    .roverSlider :focus {
                        outline: 1px solid transparent;
                    }
                    .roverSlider .rangeslider  {
                        -webkit-box-shadow: none;
                        box-shadow: none;
                    }                
                `),
            React.createElement(react_rangeslider_1.default, { min: min, max: max, value: value, onChange: onChange, tooltip: false }))));
};
exports.default = SliderComponent;
